import moment from 'moment';
import React from 'react';
import Stars from '../../Stars';
import { connect } from "react-redux";
import Chip from '../Chips';
import Icon from '../Icons/Icon';
import { P3, P3Bold, CaptionSmall, P4Bold } from '../Text';
import colours from '../Colours';
import { openPullout } from '../../../../Actions/stakeholderActions';

const BareBookingRow = (props) => {
    let booking = props.booking;
    
    const onClickBooking = () => {
        props.dispatch(openPullout(booking))
    }

    return (
        <tr className="ds-booking-row" style={{backgroundColor: props.alt ? '#F4F6F8' : 'white'}} onClick={onClickBooking}>
            <td className="align-center">
                <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                    <Chip type={booking.tab}/>
                </div>
            </td>
            <td className="align-left">
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <div style={{display: 'flex', flex: 1, flexDirection: 'column', minHeight: 72}}>
                        <div style={{marginLeft: 4, display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center'}}>
                            {booking.vehicle.Year && booking.vehicle.Make && booking.vehicle.Model? 
                                <P3Bold>{booking.vehicle.Year + " " + booking.vehicle.Make + " " + booking.vehicle.Model + (booking.vehicle.Trim ? " " + booking.vehicle.Trim : '')}</P3Bold>
                            : null }
                            {booking.vehicle.VIN? 
                                <P3 style={{color: colours.primary.grey02}}>{booking.vehicle.VIN}</P3>
                            : null }
                        </div>
                    </div>
                </div>
            </td>
            <td className="align-center" style={{minWidth: 140}}>
                <Stars star={booking.vehicle.tier[0].Rank} type={"Vehicle"}/>
            </td>
            <td className="align-center">
                <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                    {/* <BookingDateAndTime show_time={true} booking={booking}/> */}
                    <DS_BookingDateAndTime booking={booking}/>
                </div>
            </td>
            <td className="align-center">
                <P3Bold>{props.settings.vehicle_usage_types[parseInt(booking.Usage_Type)]}</P3Bold>
            </td>
            <td className="align-center">
                <P3Bold>{moment(booking.End_Date).diff(moment(booking.Start_Date), 'days')}</P3Bold>
            </td>
            <td className="align-center">
                {booking.Damage_Post ? 
                <div style={{display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                    <Icon name="Damage" size={24} style={{ borderRadius: '8px', border: `solid 1px ${colours.accent.error_red}` }}/>
                </div>
                : null
                }
            </td>
            <td className="align-center">
                {booking.expense ?
                <div style={{display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                    <Icon name="Expenses" size={24} style={{ borderRadius: '8px', border: `solid 1px ${colours.accent.error_red}` }}/>
                </div>
                    : null
                }
            </td>
        </tr>
    )
}

const DS_BookingDateAndTime = (props) => {
    let booking = props.booking;
    
    let releaseIconContainerStyle = { borderRadius: '8px', color: colours.primary.grey03, backgroundColor: colours.primary.grey05};
    let returnIconContainerStyle = { borderRadius: '8px', color: colours.primary.grey03, backgroundColor: colours.primary.grey05};
    if (booking.Released_On) {
        releaseIconContainerStyle = { borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};
        
        if (booking.Returned_On) {
            returnIconContainerStyle = { borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};
        }
    }

    return (
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <Icon name="Release" size={24} style={releaseIconContainerStyle}/>
            <div style={{textAlign: 'left', marginLeft: 4, width: 78}}>
                <P3Bold>{moment(booking.Start_Date).format('MMM DD, YYYY')}</P3Bold>
                <CaptionSmall>{moment(booking.Start_Date + " " + booking.Release_Time).format('hh:mm a')}</CaptionSmall>
            </div>
            <Icon name="ArrowRight" size={24} style={{marginLeft: 0, marginRight: 4}}/>
            <Icon name="CheckIn" size={24} style={returnIconContainerStyle}/>
            <div style={{textAlign: 'left', marginLeft: 4, width: 78}}>
                <P3Bold>{moment(booking.End_Date).format('MMM DD, YYYY')}</P3Bold>
                <CaptionSmall>{moment(booking.End_Date + " " + booking.Return_Time).format('hh:mm a')}</CaptionSmall>
            </div>
        </div>
    )
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder,
    settings: store.settings
})

const BookingRow = connect(mapStateToProps)(BareBookingRow);
export {BookingRow, DS_BookingDateAndTime}